/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_UnexpectedInputs */

const en_login_error_unexpected = /** @type {(inputs: Login_Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const ar_login_error_unexpected = /** @type {(inputs: Login_Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ ما. يُرجى المحاولة مرة أخرى.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Login_Error_UnexpectedInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_error_unexpected = /** @type {((inputs?: Login_Error_UnexpectedInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_UnexpectedInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_error_unexpected(inputs)
	return ar_login_error_unexpected(inputs)
});